<template>
  <div class="products-wrapper">
    <h1>产品展示</h1>
    <p class="products-intro">以下为关键包装部分包材定制案例，涵盖餐饮外带、饮品、烘焙等不同场景，展示包装在品牌识别、使用体验与视觉呈现上的应用方式。</p>
    <section id="products" class="products">
      <h2>包材定制案例</h2>
      <div class="cases-grid" ref="casesContainer">
        <div class="case-card" v-for="(caseItem, index) in caseStudies" :key="`case-${index}-${caseItem.title}`">
          <img
            v-if="caseItem.image"
            :src="caseItem.image"
            class="case-image"
            :alt="caseItem.title"
            @error="handleImageError($event, index)"
            @load="handleImageLoad($event, index)">
          <div class="case-content">
            <h3 class="case-title">{{ caseItem.title }}</h3>
            <p class="case-description">{{ caseItem.description }}</p>
          </div>
        </div>
      </div>
      <div class="scroll-indicator">
        <span v-for="(_, index) in 3" :key="'dot-'+index" 
              :class="{ active: activeIndex === index }"
              @click="scrollTo(index)"></span>
      </div>
      <div class="scroll-buttons">
        <button class="scroll-btn" @click="scrollLeft">← 向左滑动</button>
        <button class="scroll-btn" @click="scrollRight">向右滑动 →</button>
      </div>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
import { getWebsiteContent } from '@/api/websiteContent.js';

const defaultCaseStudies = [
  { title: '炸鸡外带包装', image: require('@/assets/images/products/chicken.png'), description: '包装设计结合手绘插图与趣味字体，展现街头小吃的活力感，鸡排、香肠、玉米等品项皆有专属结构与图案，强化产品识别度与品牌风格' },
  { title: '可降解吸管', image: require('@/assets/images/products/straw.png'), description: '吸管采用极简清爽的包装设计，品牌名称以竖排呈现品牌气质，右侧标注“纯净零添加”“耐热75°”与“PLA可降解材质”，整体强调天然、安全与环保' },
  { title: '烘焙外带包材', image: require('@/assets/images/products/bag.png'), description: '包装设计以复古蓝为主调，搭配手绘旋涡图案与简洁字体，营造质感与记忆点，整体风格温暖文艺，适合甜点品牌形象塑造与礼盒销售' },
  { title: '定制咖啡杯', image: require('@/assets/images/products/cup.png'), description: '左侧为联名纸杯，采用大胆插画风格，展现速度与工艺的结合，具收藏与话题性;右侧为品牌自用纸杯，设计简约大方，以经典黑字搭配品牌标志，突显专业与质感' },
  { title: '手提咖啡托', image: require('@/assets/images/products/hand_tray.png'), description: '这款手提杯托以深蓝色为主视觉，搭配醒目的手握咖啡插图与简洁文字，整体风格现代且富有识别性杯托结构稳固，双杯孔设计兼具美感与实用性，适合外带饮品使用，展现品牌专业调性' }
];

export default {
  name: 'ProductsView',
  data() {
    return {
      activeIndex: 0,
      scrollAmount: 370,
      caseStudies: [...defaultCaseStudies]
    };
  },
  methods: {
    scrollLeft() {
      console.log('向左滑动');
      if (this.$refs.casesContainer) {
        this.$refs.casesContainer.scrollBy({
          left: -this.scrollAmount,
          behavior: 'smooth'
        });
      }
    },
    scrollRight() {
      console.log('向右滑动');
      if (this.$refs.casesContainer) {
        this.$refs.casesContainer.scrollBy({
          left: this.scrollAmount,
          behavior: 'smooth'
        });
      }
    },
    scrollTo(index) {
      console.log('点击滚动到案例:', index + 1);
      if (this.$refs.casesContainer) {
        const position = index * this.scrollAmount;
        this.$refs.casesContainer.scrollTo({
          left: position,
          behavior: 'smooth'
        });
        this.activeIndex = index;
      }
    },
    handleScroll() {
      if (this.$refs.casesContainer) {
        const scrollPosition = this.$refs.casesContainer.scrollLeft;
        const activeIndex = Math.round(scrollPosition / this.scrollAmount);
        this.activeIndex = activeIndex;
      }
    },
    handleImageError(event, index) {
      console.error(`[产品展示] 图片加载失败 - 案例 ${index + 1}:`, {
        title: this.caseStudies[index].title,
        imageSrc: event.target.src,
        error: event
      });
    },
    handleImageLoad(event, index) {
      console.log(`[产品展示] 图片加载成功 - 案例 ${index + 1}:`, {
        title: this.caseStudies[index].title,
        imageSrc: event.target.src
      });
    }
  },
  mounted() {
    console.log('[产品展示] 页面已加载，展示包材定制案例说明');
    getWebsiteContent()
      .then((data) => {
        if (Array.isArray(data.case_studies) && data.case_studies.length > 0) {
          this.caseStudies = data.case_studies.map((c) => ({
            title: c.title || '',
            description: c.description || '',
            image: c.image_url || ''
          }));
        }
      })
      .catch(() => {});

    // 给cases-grid添加滚动事件监听
    if (this.$refs.casesContainer) {
      this.$refs.casesContainer.addEventListener('scroll', this.handleScroll);
    }
    
    // 添加键盘导航支持
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.scrollLeft();
      } else if (e.key === 'ArrowRight') {
        this.scrollRight();
      }
    });
  },
  beforeUnmount() {
    console.log('产品展示视图即将卸载');
    // 移除事件监听器
    if (this.$refs.casesContainer) {
      this.$refs.casesContainer.removeEventListener('scroll', this.handleScroll);
    }
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>

<style scoped>
.products-wrapper {
  width: 100%;
  padding-top: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.products-wrapper > h1 {
  margin-bottom: 0.8rem;
  font-size: 2rem;
  text-align: center;
  color: white;
}

.products-intro {
  font-size: 1rem;
  margin-bottom: 20px;
  color: #ccc;
  text-align: center;
  max-width: 90%;
  line-height: 1.5;
}

.products {
  background: #222;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 400px;
  padding: 40px 20px;
  box-sizing: border-box;
  border-radius: 8px;
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 20px auto;
}

/* 客户案例样式 */
.cases-grid {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  gap: 2rem;
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 40px;
  position: relative;
  scrollbar-width: thin;
  scrollbar-color: #444 #222;
}

.case-card {
  background: #222;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-width: 320px;
  max-width: 320px;
  flex: 0 0 auto;
  margin-right: 0;
  padding-top: 20px;
  position: relative;
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(229, 9, 20, 0.6), 0 0 30px rgba(229, 9, 20, 0.4);
}

.case-image {
  width: 250px;
  height: 250px;
  object-fit: cover;
  margin: 0 auto;
  display: block;
}

.case-content {
  padding: 1.5rem;
  text-align: center;
}

.case-title {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: white;
}

.case-description {
  color: #ccc;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

/* 添加滑动指示器 */
.scroll-indicator {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.scroll-indicator span {
  width: 10px;
  height: 10px;
  background: #444;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
}

.scroll-indicator span.active {
  background: #e50914;
}

/* 添加滑动按钮 */
.scroll-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
  position: relative;
  z-index: 10;
}

.scroll-btn {
  background: #333;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.scroll-btn:hover {
  background: #e50914;
}

/* 自定义滚动条样式 */
.cases-grid::-webkit-scrollbar {
  height: 8px;
}

.cases-grid::-webkit-scrollbar-track {
  background: #222;
}

.cases-grid::-webkit-scrollbar-thumb {
  background-color: #444;
  border-radius: 4px;
}
</style>